import React, { useEffect, useState, useContext } from 'react';
import useImageHandling from '../../hooks/useImageHandling';
import ImageTemplate from '../../pages/sharepost/ImageTemplate';
import PropTypes from "prop-types";
import { AuthContext } from '../../context/AuthContext';

const ImageProcessor = ({ username, details, trigger, onDoneProcessing }) => {
    const { processImages, sendHtmlToServer } = useImageHandling(username);
    // const [isInDB, setIsInDB] = useState(false);
    const [imageUrls, setImageUrls] = useState();
    const { user, fetchWishlistImagesFromDB } = useContext(AuthContext);
    const [isImageProcessorDone, setIsImageProcessorDone] = useState(false);

    useEffect(() => {
        const handleProcessImages = async () => {
            if(details.type === 'wishlist'){
                // process & send wishlist item images to indexed DB
                const imagesProcessed = await processImages(details);
                if(imagesProcessed){
                    const urls = {};
                    for (const item of details.wishlistItems) {
                        try {
                            // fetch image encodings from index db
                            const url = await fetchWishlistImagesFromDB(user.username, item.name);
                            urls[item.name] = url;
                        } catch (error) {
                            console.error(`Failed to load image for ${item.name}:`, error);
                            urls[item.name] = null; // Or a default image URL
                        }
                    }
                    // console.log(JSON.stringify(urls, null, 2));
                    setImageUrls(urls);
                    setIsImageProcessorDone(true);
                    // process & send share images to indexed DB
                    const sent = await sendHtmlToServer();
                    if(sent){
                        if(onDoneProcessing){
                            onDoneProcessing();
                        }
                    }
                }
                // link currency
            } else if (details.type === 'currency'){

                // set to true so the image template can render the images for download
                setIsImageProcessorDone(true);
                await new Promise(resolve => setTimeout(resolve, 100));
                // process & send share images to indexed DB
                const sent = await sendHtmlToServer();
                if(sent){
                    if(onDoneProcessing){
                        onDoneProcessing();
                    }
                }
            } else if (details.type === 'item'){
                // process & send wishlist item images to indexed DB
                const imagesProcessed = await processImages(details);
                if(imagesProcessed){
                    const urls = {};
                    // fetch image encodings from index db
                    const url = await fetchWishlistImagesFromDB(user.username, details.title);
                    urls[details.title] = url;
                
                    setImageUrls(urls);
                    setIsImageProcessorDone(true);
                    await new Promise(resolve => setTimeout(resolve, 100));
                    // process & send share images to indexed DB
                    const sent = await sendHtmlToServer();
                    if(sent){
                        if(onDoneProcessing){
                            onDoneProcessing();
                        }
                    }
            }
        }
    }
    if(trigger){
        setIsImageProcessorDone(false);
        // setIsInDB(false);
        setImageUrls({}); // Reset imageUrls
        handleProcessImages();
    }
    }, [trigger]);

    return (
        <>
            {/* Render ImageTemplate offscreen */}
            <div
                id="img-processor"
                style={{
                    position: 'absolute',
                    left: '-9999px',
                    top: '-9999px',
                    // visibility: 'hidden',
                }}
            >
                {isImageProcessorDone &&
                    <ImageTemplate details={details} scale={3} idName={'downloadImageTemplate'} imageUrls={imageUrls} />
                }
            </div>
        </>
    );
};

export default ImageProcessor;

ImageProcessor.propTypes = {
    details: PropTypes.object,
    username: PropTypes.string,
    trigger: PropTypes.bool,
    onDoneProcessing: PropTypes.func,
};

